




import Vue from 'vue';

type Login = {
    user_name: string;
    user_password: string;
}
export default class extends Vue {

    Login() {
        console.log(Vue.axios);

        console.log('hi');

    }


}


